import {ExpenseReport} from '../expenseReport';

export function toString(this: ExpenseReport) {
    return `Deal: ${this.id}`;
}
